import { Component, ViewContainerRef, ViewChild } from "@angular/core";
import { IFilterAngularComp } from "ag-grid-angular";
import {
  IFilterParams,
  RowNode,
  IDoesFilterPassParams,
} from "ag-grid-community";
import { BooleanDropdownFloatingFilter } from "../boolean-dropdown-floating-filter/boolean-dropdown-floating-filter.component";

@Component({
  selector: "app-boolean-dropdown-filter",
  templateUrl: "./boolean-dropdown-filter.component.html",
  styleUrls: ["./boolean-dropdown-filter.component.css"],
})
export class BooleanDropdownFilter implements IFilterAngularComp {
  private params: IFilterParams;
  private valueGetter: (rowNode: RowNode) => any;
  public type: any = ""; // need to be public for --prod compile

  @ViewChild("select", { read: ViewContainerRef }) public select;

  isFilterActive(): boolean {
    return true;
  }
  doesFilterPass(params: IDoesFilterPassParams): boolean {
    return this.type
      .toLowerCase()
      .split(" ")
      .every((filterWord) => {
        const data =
          this.valueGetter(params.node) === undefined ||
          this.valueGetter(params.node) === null
            ? ""
            : this.valueGetter(params.node);
        return data.toString().toLowerCase().indexOf(filterWord) >= 0;
        // return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= 0;
      });
  }
  getModel() {
    return { value: this.type };
  }
  setModel(model: any): void {
    this.type = model ? model.value : "";
  }

  getModelAsString(model: any): string {
    return model ? model.value : "";
  }

  agInit(params: IFilterParams): void {
    this.params = params;
    this.valueGetter = params.valueGetter;
    // this.params.colDef.floatingFilterComponent = BooleanDropdownFloatingFilter;
  }

  onChange(newValue): void {
    if (this.type !== newValue) {
      this.params.clearButton = true;
      this.type = newValue;
      this.params.filterChangedCallback();
    }
  }

  onFloatingFilterChanged(newValue): void {
    this.onChange(newValue);
  }
}
